<template>
  <div>
    <div style="height: 70px;"></div>
    <div class="step-layer">
      <div class="step">
        <div class="step-item current">
          <div class="step-icon">1</div>
          <div class="step-title" v-text="$t('adv_common.first') + $t('adv_common.end')"></div>
        </div>
        <div class="step-line"></div>
        <div class="step-item current">
          <div class="step-icon">2</div>
          <div class="step-title" v-text="$t('adv_common.second') + $t('adv_common.end')"></div>
        </div>
        <div class="step-line"></div>
        <div class="step-item current">
          <div class="step-icon">3</div>
          <div class="step-title" v-text="$t('adv_common.third')"></div>
        </div>
      </div>
    </div>

    <div class="btn">
      <div v-text="$t('create_adv.title')"></div>
      <div class="group-desc" v-text="$t('create_adv.desc')"></div>
    </div>

    <div class="layer">
      <div class="one-line">
        <span class="title" v-text="$t('create_adv.group_name')"></span>{{ group_name }}
        <span class="title" style="margin-left: 30px;" v-show="content !== ''" v-text="$t('create_adv.keyword')"></span>{{ content }}
      </div>
      <div class="adv-desc" v-text="$t('create_adv.keyword_desc')"></div>
    </div>

    <div class="layer-2">
      <div class="left-content">
        <div class="left-header" v-text="$t('create_adv.title2')"></div>
        <el-input v-model="form.url" :placeholder="$t('create_adv.url')" size="small"></el-input>
        <div class="left-title" v-text="$t('create_adv.name')"></div>
        <el-input type="text" :placeholder="$t('create_adv.name_p')" v-model="form.title" maxlength="30" size="small" show-word-limit style="margin-top: 5px;"></el-input>
        <div class="left-title" style="display: flex; align-items: center;">{{ $t('create_adv.upload') }}
          <el-upload class="avatar-uploader"
            :action="getLink()"
            v-bind:on-progress="uploadVideoProcess"
            v-bind:on-success="handleVideoSuccess"
            v-bind:before-upload="beforeUploadVideo"
            v-bind:show-file-list="false">
            <el-button size="mini" style="margin-left: 10px;" v-text="$t('create_adv.upload_btn')"></el-button>
              <el-progress v-if="videoFlag == true"
                 type="circle"
                 v-bind:percentage="videoUploadPercent"
                 style="margin-top:7px;"></el-progress>
          </el-upload>
        </div>
        <div class="video" style="width: 490px; height: 200px; display: flex; justify-content: center;">
           <video v-show="form.video_path !='' && !videoFlag"
            v-bind:src="getShowLink()"
            class="avatar video-avatar"
            controls="controls"
            style="margin-top: 10px;">
               not support the video component!!!
           </video>
        </div>
      </div>
      <div class="right-content">
        <div class="top-content">
          <div class="top-header" v-text="$t('create_adv.right_title')"></div>
          <div class="content">
            <div class="left-svg">
              <el-progress type="circle" :percentage="65" :width="80" :show-text="false"></el-progress>
              <div class="font" v-text="$t('create_adv.state')"></div>
            </div>
            <div class="right-line">
              <div class="right-header" v-text="$t('create_adv.right_keyword')"></div>
              <div class="line"><i class="el-icon-star-on"></i>{{ $t('create_adv.keyword1') }}</div>
              <div class="line"><i class="el-icon-star-on"></i>{{ $t('create_adv.keyword2') }}</div>
              <div class="line"><i class="el-icon-star-on"></i>{{ $t('create_adv.keyword3') }}</div>
              <div class="line"><i class="el-icon-star-on"></i>{{ $t('create_adv.keyword4') }}</div>
            </div>
          </div>
        </div>
        <div class="bottom-view">
          <div class="title" v-text="$t('create_adv.look')"></div>
          <div class="padding-content" v-text="$t('create_adv.look_content')"></div>
        </div>
      </div>
    </div>

    <div class="btn">
      <el-button type="primary" size="small" @click="save" v-text="$t('adv_common.save_btn2')"></el-button>
      <el-button type="text" @click="cancel" v-text="$t('common.layer_btn_cancel')"></el-button>
    </div>
    <div style="height: 100px;"></div>
  </div>

</template>

<script>
export default {
  name: 'createAdv',
  props: ['adv_data', 'group_id'],
  data() {
    return {
      form: {
        adv_id: '',
        plan_id: '',
        group_id: '',
        url: '',
        title: '',
        video_path: ''
      },
      videoFlag: false,
      videoUploadPercent: '',
      isShowUploadVideo: false,
      group_name: '',
      content: '',
      type: 'add',
      group_lists: []
    };
  },
  created() {
    this.form.group_id = this.group_id;
    let title = this.$t('create_adv.create');
    if (this.adv_data.adv_id !== undefined && parseInt(this.adv_data.adv_id) > 0) {
      this.form = {
        adv_id: this.adv_data.adv_id,
        plan_id: this.adv_data.plan_id,
        group_id: this.adv_data.group_id,
        url: this.adv_data.url,
        title: this.adv_data.title,
        video_path: this.adv_data.video_path
      };
      this.type = 'edit';
      title = this.$t('create_adv.edit');
    }

    this.$http.post('/trader/index/getGroupInfo', {
      group_id: this.group_id
    }).then(res => {
      if (res.code === 200) {
        this.form.plan_id = res.data.plan_id;
        this.form.group_id = res.data.group_id;
        this.group_name = res.data.group_name;
        this.content = res.data.content.join(',');
        this.form.url = this.form.url === '' ? res.data.url : this.form.url;
        this.$function.hiddenLoading();
      }
    });
    document.title = `${title}` + this.$t('create_adv.adv');
  },
  methods: {
    getShowLink() {
      return this.$Config.apiUrl + this.form.video_path;
    },
    save() {
      if (this.form.url === '') {
        this.$message.error(this.$t('create_adv.url_verify'));
        return false;
      }
      if (this.form.title === '') {
        this.$message.error(this.$t('create_adv.title_verify'));
        return false;
      }
      if (this.form.video_path === '') {
        this.$message.error(this.$t('create_adv.video_verify'));
        return false;
      }
      const url = this.type === 'add' ? '/trader/index/createAdv' : '/trader/index/saveAdv';
      this.$http.post(url, this.form).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('create_adv.success'));
          this.cancel();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    cancel() {
      this.$emit('jump_adv', 'AdvView');
    },
    getLink() {
      return this.$Config.apiUrl + '/index/index/fileUpload';
    },
    // 上传前回调
    beforeUploadVideo(file) {
      var fileSize = file.size / 1024 / 1024 < 100;
      if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'].indexOf(file.type) === -1) {
        this.$message.error(this.$t('create_adv.video_type'));
        return false;
      }
      if (!fileSize) {
        this.$message.error(this.$t('create_adv.video_size'));
        return false;
      }
      this.isShowUploadVideo = false;
    },
    // 进度条
    uploadVideoProcess(event, file, fileList) {
      this.videoFlag = true;
      this.videoUploadPercent = file.percentage.toFixed(0) * 1;
    },
    // 上传成功回调
    handleVideoSuccess(res, file) {
      this.isShowUploadVideo = true;
      this.videoFlag = false;
      this.videoUploadPercent = 0;
      // 后台上传地址
      if (res.code === 200) {
        this.form.video_path = res.path;
      } else {
        this.$message.error(res.msg);
      }
    }
  }
};
</script>

<style lang="less" scoped="">
  .btn {
    width: 1088px;
    margin: 40px auto;
    font-size: 15px;
    color: #222;
    .group-desc {
      margin-top: 20px;
      color: rgba(32,33,36,.86);
      font-size: 13px;
    }
  }
  .layer {
    width: 1024px;
    padding: 24px 32px;
    margin: 20px auto;
    background: #fff;
    font-size: 14px;
    box-shadow: 0 6px 10px 0 rgba(0,0,0,.14), 0 1px 18px 0 rgba(0,0,0,.12), 0 3px 5px -1px rgba(0,0,0,.2);
    color: rgba(32,33,36,.86);
    .adv-desc {
      font-size: 13px;
      margin-top: 20px;
      padding-top: 10px;
      border-top: 1px solid rgba(32,33,36,.86);
    }

    .one-line {
      .title {
        color: #757575;
      }
    }
  }

  .layer-2 {
    width: 1088px;
    margin: 20px auto;
    background: #fff;
    font-size: 14px;
    box-shadow: 0 6px 10px 0 rgba(0,0,0,.14), 0 1px 18px 0 rgba(0,0,0,.12), 0 3px 5px -1px rgba(0,0,0,.2);
    display: flex;

    .left-content {
      width: 488px;
      padding: 16px;
      background: #fff;
      color: rgba(32,33,36,.86);
      .left-header {
        font-size: 12px;
        margin-bottom: 10px;
      }
      .left-title {
        font-size: 14px;
        margin-top: 10px;
      }
    }
    .right-content {
      width: calc(100% - 520px);
      color: rgba(32,33,36,.86);
      .top-content {
        padding: 16px;
        box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.12), 0 1px 5px 0 rgba(0,0,0,.2);
        .top-header {
          font-size: 14px;
        }
        .content {
          display: flex;
          .left-svg {
            width: 140px;
            text-align: center;
            padding: 30px;

            .font {
              width: 100%;
              font-size: 14px;
              text-align: center;
              margin-top: 10px;
            }
          }
          .right-line {
            width: calc(100% - 140px);
            font-size: 13px;
            .right-header {
              border-bottom: 2px solid rgba(0,0,0,.26);;
              padding-bottom: 10px;
              margin-bottom: 10px;
            }
            .line {
              height: 30px;
              line-height: 30px;
            }
          }
        }
      }
      .bottom-view {
        height: 160px;
        padding: 16px;
        background: #F1F3F4;
        .padding-content {
          padding: 30px;
          color: #5f6368;
          font-size: 12px;
        }
      }
    }
  }

  .step-layer {
    width: 100%;
    background: #fff;
    height: 70px;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.12), 0 1px 5px 0 rgba(0,0,0,.2);
    display: flex;
    align-items: center;
    position: fixed;
    top: 66px;
    background: #fff;
    z-index: 2;
    .step {
      margin-left: 30px;
      display: flex;
      align-items: center;
      .step-item {
        display: flex;
        align-items: center;
        font-size: 14px;
        .step-icon {
          width: 28px;
          height: 28px;
          text-align: center;
          line-height: 28px;
          color: #fff;
          background: #616161;
          border-radius: 50%;
          font-size: 12px;
          margin-right: 8px;
        }
      }
      .step-line {
        width: 50px;
        height: 1px;
        background: #BDBDBD;
        margin: 0 8px;
      }
      .current {
        .step-icon {
          background: #4285F4;
        }
      }
    }
  }

  .avatar-uploader .el-upload {
    width: 500px !important;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    text-align: left !important;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    // height: 178px;
    // line-height: 178px;
    text-align: center;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
  }
  .avatar {
    height: 210px;
    // height: 178px;
    display: block;
  }
</style>
